.become-member-buttons {
  display: flex;
  justify-content: space-between;
}
.become-member-buttons button {
  width: 245px;
  margin: 15px 5px;
}

@media screen and (max-width: 800px) {
  .become-member-buttons button {
    width: 90%;
    font-size: 14px !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvb3JnYW5pc21zL21lbWJlcnNoaXBzIiwic291cmNlcyI6WyJiZWNvbWUtbWVtYmVyLWJ1dHRvbnMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJO0VBQ0E7O0FBRUE7RUFDSTtFQUNBOzs7QUFJUjtFQUVRO0lBQ0k7SUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5iZWNvbWUtbWVtYmVyLWJ1dHRvbnMge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuXG4gICAgYnV0dG9uIHtcbiAgICAgICAgd2lkdGg6IDI0NXB4O1xuICAgICAgICBtYXJnaW46IDE1cHggNXB4O1xuICAgIH1cbn1cblxuQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogODAwcHgpe1xuICAgIC5iZWNvbWUtbWVtYmVyLWJ1dHRvbnMge1xuICAgICAgICBidXR0b24ge1xuICAgICAgICAgICAgd2lkdGg6IDkwJTtcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMTRweCFpbXBvcnRhbnQ7XG4gICAgICAgIH1cbiAgICB9XG59Il19 */